import React from 'react';
import { Panel, Big } from './parts';

export const WatchCompare = ({ w }) => {
  const lift = w.watcher_rate > 0 && w.non_watcher_rate > 0 ? (w.watcher_rate / w.non_watcher_rate).toFixed(1) : null;
  return (
    <Panel title="Do video watchers sign up more?" testId="growth-watch-compare">
      <div className="grid grid-cols-2 gap-4">
        <div className="rounded-xl bg-blue-50 p-4">
          <Big label="Watched 25% or more" value={`${w.watcher_rate}%`} tone="text-[#00247D]" testId="growth-watcher-rate"
            sub={`${w.watcher_signups} of ${w.watchers} signed up`} />
        </div>
        <div className="rounded-xl bg-slate-50 p-4">
          <Big label="Didn't watch" value={`${w.non_watcher_rate}%`} testId="growth-non-watcher-rate"
            sub={`${w.non_watcher_signups} of ${w.non_watchers} signed up`} />
        </div>
      </div>
      <p className="text-sm text-slate-600 mt-4" data-testid="growth-lift">
        {lift
          ? <>Visitors who watched sign up <b>{lift}×</b> as often as those who didn't.</>
          : 'Once both groups have signups, this shows how much more often watchers sign up.'}
      </p>
      <p className="text-xs text-slate-400 mt-2">Each visitor gets an anonymous ID in their browser, linked to the account only if they sign up.</p>
    </Panel>
  );
};
